var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classes},[(_vm.finalViewonly || _vm.finalReadonly)?[_c('span',{class:_vm.prefixCls + '-text-content'},[_vm._v(_vm._s(_vm.textContent))])]:[_vm._t("default")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }